module.exports = __webpack_public_path__ + "static/media/pv.4e8f15a0.png";